module.exports = __webpack_public_path__ + "img/chess_japanchess08.5d75b21a.png";